<template>
  <div ref="footer">
    <slot name="bottom"></slot>
    <div class="footer">
      <!-- 海门 -->
      <div v-if="clientId== 320684" class="main">
        <!-- 网站服务 开始 -->
        <div class="service clear">
          <dl class="service-1">
            <dt>产品和服务</dt>
            <dd>
              <a href="http://www.jshmzc.com/" target="_black">海门之窗</a>
            </dd>
            <dd>
              <a>东洲城事</a>
              <div class="qrcode" style="left:50px;top: 125px;">
                <img src="/public/w/img/320684/dzcs.png">
                <p>iphone &amp; Android</p>
                <span>微信扫一扫 东洲城事</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <dd style="left:50px;top: 130px;">
              <a href="http://gdt.haimen.gov.cn/" target="_black">海门市广播电视台</a>
            </dd>
            <dd>
              <a>广电之星</a>
              <div class="qrcode" style="left:50px;top: 170px;">
                <img src="/public/w/img/320684/gdzx.jpg">
                <p>iphone &amp; Android</p>
                <span>微信扫一扫 广电之星</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <dd>
              <a>海门日报</a>
              <div class="qrcode" style="top: 210px;">
                <img src="/public/w/img/320684/hmrb.jpg">
                <p>iphone &amp; Android</p>
                <span>微信扫一扫 海门日报</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            
            
            <dd>
              <a>FM100.6</a>
              <div class="qrcode" style="left:50px;top: 210px;">
                <img src="/public/w/img/320684/fm1006.jpg">
                <p>iphone &amp; Android</p>
                <span>微信扫一扫 FM100.6海门广播</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <dd></dd>
            <dd>
              <a>海门电视台教育频道</a>
              <div class="qrcode" style="left:50px;top: 255px;">
                <img src="/public/w/img/320684/edu.png">
                <p>iphone &amp; Android</p>
                <span>微信扫一扫 海门电视台教育频道</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            
            
            
            
          </dl>
          <dl class="service-2">
            <dt>关于我们</dt>
            <dd>
              <a :href="'http://wwwvideo.jshmtv.com/web/program/about#jianjie'">关于我们</a>
            </dd>
            <dd>
              <a :href="'http://wwwvideo.jshmtv.com/web/program/about#xinwen'">新闻热线</a>
            </dd>
            <dd>
              <a :href="'http://wwwvideo.jshmtv.com/web/program/about#guanggao'">广告服务</a>
            </dd>
          </dl>
          <dl class="service-3">
            <dt>免责声明</dt>
            <dd>本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。</dd>
            <dd>如您因版权等问题需要与本网联络，请在30日内联系我们。</dd>
            <dd>本网站法律顾问：江苏剑桥人律师事务所严文戟律师</dd>
          </dl>
          <dl class="service-4">
            <dt>APP下载</dt>
            <dd>
              <img src="/public/w/img/320684/download.jpg">
            </dd>
          </dl>
        </div>
        <!-- 网站服务 结束 -->

        <!-- 网站版权 开始 -->
        <div class="copy">
          <p>版权所有 © 海门电视台 2018 <a target="blank" style="color:#ffffff;display:inline-block;text-decoration:none;height:20px;line-height:20px;" href="http://www.beian.miit.gov.cn">苏ICP备17033365号</a> 苏新网备2008040号 <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32068402000163" style="color:#ffffff;display:inline-block;text-decoration:none;height:20px;line-height:20px;">苏公网安备 32068402000163号</a></p>
          <img src="/public/w/img/pc/beianlogo.png" style="
    vertical-align: middle;
    margin-left:  10px;
    height: 20px;
">

        </div>
        <!-- 网站版权 结束 -->
      </div>
      <!-- 吴江 -->
      <div v-if="clientId== 320598" class="main">
        <!-- 网站服务 开始 -->
        <div class="service clear">
          <dl class="service-1">
            <dt>产品和服务</dt>
            <dd>
              <a href="https://www.wjdaily.com/" target="_black">吴江新闻网</a>
            </dd>
            <dd>
              <a href="http://bbs.wjdaily.com/bbs/portal.php" target="_black">东太湖论坛</a>
            </dd>
            <dd>
              <a>今吴江客户端</a>
              <div class="qrcode" style="top: 170px;">
                <img src="/public/w/img/320598/ewm.png">
                <p>iphone &amp; Android</p>
                <span>扫一扫下载今吴江APP</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <dd>
              <a href="http://epaper.ljwj150.com" target="_black">吴江日报数字报</a>
            </dd>
            <dd>
              <a href="http://weibo.com/lejuwj" target="_black">苏州吴江发布微博</a>
            </dd>
            <dd>
              <a>融媒吴江</a>
              <div class="qrcode" style="top: 215px;left:29px">
                <img src="/public/w/img/320598/wjrb.jpg">
                <span>扫一扫关注融媒吴江</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <!-- <dd>
              <a>吴江微报微信</a>
              <div class="qrcode" style="top: 260px;left:50px;">
                <img src="/public/w/img/320598/wjwb.jpg">
                <span>扫一扫关注吴江微报</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd> -->
            <!-- <dd>
              <a href="http://www.taihu-mall.com/shop/index.php" target="_black">东太湖云商城</a>
            </dd> -->
          </dl>
          <dl class="service-2">
            <dt>关于我们</dt>
            <dd>
              <a :href="host+'/news/about'">关于我们</a>
            </dd>
            <dd>
              <a :href="host+'/news/about#rexian'">新闻热线</a>
            </dd>
            <dd>
              <a :href="host+'/news/about#guanggao'">广告服务</a>
            </dd>
          </dl>
          <dl class="service-3">
            <dt>免责声明</dt>
            <dd>本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。</dd>
            <dd>如您因版权等问题需要与本网联络，请在30日内联系我们。</dd>
            <dd>本网站法律顾问：江苏剑桥人律师事务所严文戟律师</dd>
          </dl>
          <dl class="service-4">
            <dt>APP下载</dt>
            <dd>
              <img src="/public/w/img/320598/ewm.png">
            </dd>
            <dd>今吴江</dd>
          </dl>
        </div>
        <!-- 网站服务 结束 -->

        <!-- 网站版权 开始 -->
        <div class="copy">
          <p>版权所有 © 吴江融媒体中心 2019 <a target="blank" style="color:#ffffff;display:inline-block;text-decoration:none;height:20px;line-height:20px;" href="http://www.beian.miit.gov.cn">苏ICP备10217754号</a> 苏新网备2008040号 <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050902100461 &#10;&#10;" style="color:#ffffff;display:inline-block;text-decoration:none;height:20px;line-height:20px;">苏公网安备 32050902100461号</a></p>
          <img src="/public/w/img/pc/beianlogo.png" style="
    vertical-align: middle;
    margin-left:  10px;
    height: 20px;
">
          <div class="share clear">
            <div class="bdsharebuttonbox bdshare-button-style0-32">
              <a class="top_btn" @click="smoothscroll()" style="display:inline-block"></a>
            </div>
          </div>
          <div class="map">
            <div class="tel">
              <div class="tel1"></div>
              <div class="tel2">
                <a href="http://www.12377.cn/" target="_blank"></a>
              </div>
              <div class="tel3"></div>
            </div>
            <div class="fri-link">
              <div class="link1">
                <a href="http://bszs.conac.cn/sitename?method=show&amp;id=540510F517164DF6E053022819AC95AE" target="_blank"></a>
              </div>
              <div class="link2">
                <a href="http://61.155.26.218/license?id=9207" target="_blank"></a>
              </div>
              <div class="link3"></div>
              <div class="link4">
                <a href="http://www.12315.cn/" target="_blank"></a>
              </div>
              <div class="link5">
                <a href="http://61.155.26.218/license/credit?id=9207" target="_blank"></a>
              </div>
              <div class="link6">
                <a href="http://61.155.26.218/license/credit?id=9207" target="_blank"></a>
              </div>
            </div>
          </div>
        </div>
        <!-- 网站版权 结束 -->
      </div>

      <div v-if="clientId==410600" class="footer-tag-list main center">
        <!-- 网站服务 开始 -->
        <div class="service  clear">

          <div>
            <a :href="host+'/news/about'">关于我们</a>
            <a href="https://www.henanjubao.com/" target="_black">河南省互联网违法和不良信息举报中心</a>
            <a href="http://www.12377.cn" target="_black">中国互联网违法和不良信息举报中心入口</a>
            <a>举报电话:0392-3331766</a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41061102000115" target="_black">豫公网安备 41061102000115号</a>

          </div>
        </div>
        <!-- 网站服务 结束 -->

        <!-- 网站版权 开始 -->
        <div class="copy">
          <p>版权所有 © 鹤壁市广播电视台
            <a href="http://bszs.conac.cn/sitename?method=show&id=0EC7E26666AF726AE053022819AC80CC" target="_black">
              <img src="http://dcs.conac.cn/image/blue.png" alt="">
            </a>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_black">
              2018 豫ICP备05017900号-1 | 互联网视听节目服务 ( AVSP ): 豫网备 2016002 号
              </a>
              <a href="javascript:;">互联网新闻许可证: 41120180010</a>
              <a id="_xinchacharenzheng_cert_vip_kexinweb" style="text-decoration: none;width: 200px;line-height: 106px;display: block;margin: auto;" target="_blank" href="https://myssl.com/seal/detail?domain=www.hebitv.com">
                <img src="https://sealres.myssl.com/seal/img/2x/seal.png?domain=www.hebitv.com" style="height: 106px;width: 200px;">
              </a>
              <!-- <a id="_xinchacharenzheng_cert_vip_kexinweb" style="text-decoration:none;" target="_blank" href="https://xyt.xinchacha.com/getpcInfo?sn=1493056523021049856&certType=8&url=*.hebitv.com">
                <img src="https://xyt.xinchacha.com/img/icon/icon8.png" style="height:50px;width:164px;">
              </a> -->
              </p>
          <div class="share clear">
            <div class="bdsharebuttonbox bdshare-button-style0-32">
              <a class="top_btn" @click="smoothscroll()" style="display:inline-block"></a>
            </div>
          </div>
        </div>
      </div>
      <!-- 宿迁 -->
      <div v-if="clientId==321300" class="footer-tag-list main center">
        <a href="https://www.12377.cn" target="_blank"><img style="width:1010px;height:65px;display:block;margin:20px auto 0" src="/public/w/img/321300/jubao.png"></a>
        <div class="bottom bottomsq">
          <div class="fo_con">
            <div class="fo1">Copyright © 2018</div>
            <div class="fo2">中共宿迁市委宣传部
              <br>宿迁报业网络传媒有限公司</div>
            <div class="fo3" style=" line-height: 19px;">
              <a style="display: block;margin-top: 20px;font-size: 12px;" href="https://beian.miit.gov.cn/">备案号：苏ICP备10105892号-14</a>
              <a style="display: block;font-size: 12px;" href="javascript:;">互联网新闻许可：32120180020</a>
            </div>
            <div class="fo4"> 违法信息举报电话：0527-84389919
              <br>违法信息举报邮箱：suxinwen2015@126.com              
            </div>
            <div class="fo5">Powered by
              <a href="#">速新闻</a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="clientId== 320100" class="main">
        <!-- 网站服务 开始 -->
        <div class="service clear">
          <dl class="service-1">
            <dt>产品和服务</dt>
            <dd>
              <a>爱南京客户端</a>
              <div class="qrcode" style="top: 120px;">
                <img src="/public/w/img/320100/ewm.png">
                <p>iphone &amp; Android</p>
                <span>扫一扫下载爱南京APP</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <dd>
              <a>南京晨报小记者</a>
              <div class="qrcode" style="top: 120px;left:50px;">
                <img src="/public/w/img/320100/xiaojizhe.png">
                <span>扫一扫关注小记者</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <dd>
              <a>南京晨报微信</a>
              <div class="qrcode" style="top: 165px;">
                <img src="/public/w/img/320100/weixin.png">
                <span>扫一扫关注南京晨报</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <dd>
              <a>南京晨报乔医生</a>
              <div class="qrcode" style="top: 165px;left:50px;">
                <img src="/public/w/img/320100/doctorqiao.png">
                <span>扫一扫关注乔医生</span>
                <i>
                  <img src="/public/w/img/pc/index_03.png">
                </i>
              </div>
            </dd>
            <dd>
              <a href="https://www.inanjin.com/" target="_black">南京晨报网</a>
            </dd>
            <dd>
              <a href="http://njcb.jschina.com.cn" target="_black">南京晨报数字报</a>
            </dd>

            <dd>
              <a href="https://weibo.com/nanjingchenbao?topnav=1&topsug=1" target="_black">南京晨报微博</a>
            </dd>


          </dl>
          <dl class="service-2">
            <dt>关于我们</dt>
            <dd>
              <a :href="host+'/news/about'">关于我们</a>
            </dd>
            <dd>
              <a :href="host+'/news/about#rexian'">新闻热线</a>
            </dd>
            <dd>
              <a :href="host+'/news/about#guanggao'">广告服务</a>
            </dd>
          </dl>
          <dl class="service-3">
            <dt>免责声明</dt>
            <dd>本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。</dd>
            <dd>如您因版权等问题需要与本网联络，请在30日内联系我们。</dd>
            <dd>任何媒体不得擅自转载本网站由其他单位提供的信息和服务内容，如需转载，必须与本网站联系获得合法授权。</dd>
            <dd>举报电话：025-58682396</dd>
          </dl>
          <!-- 网站服务 结束 -->

          <!-- 网站版权 开始 -->
          <div class="copy">
            <p>版权所有 © 南京晨报社</p>
            <div class="share clear">
              <div class="bdsharebuttonbox bdshare-button-style0-32">
                <a class="top_btn" @click="smoothscroll()" style="display:inline-block"></a>
              </div>
            </div>
          </div>
          <!-- 网站版权 结束 -->
        </div>
        <!-- 网站版权 结束 -->
      </div>
      <!-- 今日濮阳 -->
      <div v-if="clientId==410900" class="footer-tag-list main center">
        <!-- 网站服务 开始 -->
        <div class="service  clear">
          <div>
            <!-- <a :href="host+'/news/about'">关于我们</a> -->
            <a href="http://www.12377.cn" target="_black">中国互联网违法和不良信息举报中心入口</a>
            <a href="https://www.henanjubao.com/" target="_black">河南省互联网违法和不良信息举报中心</a>
            <a href="https://www.pyxww.com/pyshlwjbzx/" target="_black">濮阳市互联网违法和不良信息举报中心</a>
            
            <!-- <a>举报电话:0392-3331766</a> -->
            <!-- <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41061102000115" target="_black">豫公网安备 41061102000115号</a> -->

          </div>
        </div>
        <div class="service  clear" style="padding-top: 0">
         <a href="javascript:;" style="cursor: auto;">违法和不良信息举报电话：0393-4690809</a>
         <a href="javascript:;" style="cursor: auto;">涉未成年人举报电话：0393-4690809</a>
         <a href="javascript:;" style="cursor: auto;">举报邮箱:pytvxmt@qq.com</a>
        </div>
        <div class="service  clear" style="padding-top: 0">
          <a id="_xinchacharenzheng_cert_vip_ssl" style="text-decoration:none;" target="_blank" href="https://xyt.xinchacha.com/getpcInfo?sn=1400380390676688896&certType=8">
            <img src="https://xyt.xinchacha.com/img/icon/icon8.png" style="height:50px;width:164px;">
          </a>
        </div>
        <!-- 网站服务 结束 -->

        <!-- 网站版权 开始 -->
        <div class="copy">
          <p>版权所有 © 濮阳市广播电视台
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_black">
              豫ICP备20018960号-1
            </a>
            <!-- <a href="javascript:;">互联网新闻许可证: </a> -->
          </p>
        </div>
      </div>
      <!-- 底部开始 结束 -->
    </div>
  </div>
</template>
<style scoped>
  @import './footer.css';
</style>
<script type="text/javascript"></script>
<script>
  export default {
    props: ['clientId'],
    data() {
      return {
        host: '#'
      };
    },
    mounted() {
      console.log(this.clientId)
      this.host = location.origin;
      const {
        pathname,
        hash
      } = window.location;
      this.selectedMenu = pathname.toLowerCase() + hash.toLowerCase();

      const footer = this.$refs.footer;
      const setFooterMarginTop = () => {
        const {
          clientHeight
        } = document.documentElement;
        const {
          offsetTop
        } = footer;
        let marginTop = footer.style.marginTop.replace('px', '') * 1;
        if (isNaN(marginTop)) {
          marginTop = 0;
        }
        marginTop = Math.max(0, marginTop);
        const newMarginTop = Math.max(clientHeight - offsetTop - footer.clientHeight + marginTop, 0);
        if (newMarginTop != marginTop) {
          footer.style.marginTop = `${newMarginTop}px`;
        }
      };
      window.onresize = setFooterMarginTop;
      setFooterMarginTop();

      // document.body.insertAdjacentHTML('beforeend',
      //   '<script language="javascript" type="text/javascript" src="http://js.users.51.la/18321340.js"><\/script>');
      /*   setInterval(setFooterMarginTop, 200); */
    },
    methods: {
      // 返回顶部
      smoothscroll() {
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(this.smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 5);
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// app/web/component/web/news-layout/footer/footer.vue